export function getSourceForInstance(instance: any) {
  return Object.getPrototypeOf(instance);
}
